var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-form',{attrs:{"endpoint":"motivo-aula-compensada","rota-base":"/admin/motivo-aula-compensada","titulo-singular":"Motivo de A.C","campos-extras":[
        { campo: "descricao", label: "Descrição", tipo: "text" }
    ]}})
}
var staticRenderFns = []

export { render, staticRenderFns }